<footer class="guest-footer">
  <div class="guest-footer__main">
    <!-- <div class="container"> -->
      <div class="row guest-footer__row">
        <!-- Left Section: Navigation Links -->
        <div class="guest-footer__content ">
          <div class="guest-footer__navigation">
            <!-- Company Column -->
            <div class="guest-footer__column">
              <h4 class="guest-footer__column-title">Company</h4>
              <ul class="guest-footer__links">
                @for (link of companyLinks; track link.label) {
                  <li>
                    <a 
                      [routerLink]="link.route" 
                      class="guest-footer__link"
                      [target]="link.openInNewTab ? '_blank' : '_self'"
                      [attr.rel]="link.openInNewTab ? 'noopener noreferrer' : null"
                    >{{ link.label }}</a>
                  </li>
                }
              </ul>
            </div>

            <!-- Product Column -->
            <div class="guest-footer__column">
              <h4 class="guest-footer__column-title">Product</h4>
              <ul class="guest-footer__links">
                @for (link of productLinks; track link.label) {
                  <li>
                    <a [routerLink]="link.route" class="guest-footer__link">{{ link.label }}</a>
                  </li>
                }
              </ul>
            </div>

            <!-- Resources Column -->
            <div class="guest-footer__column">
              <h4 class="guest-footer__column-title">Resources</h4>
              <ul class="guest-footer__links">
                @for (link of resourcesLinks; track link.label) {
                  <li>
                    <a [routerLink]="link.route" class="guest-footer__link">{{ link.label }}</a>
                  </li>
                }
              </ul>
            </div>
          </div>

          <!-- Language Selector and Social Media Icons -->
          <div class="guest-footer__interactive">
            <!-- Language Selector -->
            <div class="guest-footer__language-wrapper">
              <button 
                type="button"
                class="guest-footer__language-selector"
                (click)="toggleLanguageDropdown()"
                [attr.aria-expanded]="languageDropdownOpen"
              >
                <i class="bi bi-globe"></i>
                <span>{{ selectedLanguage }}</span>
                <i class="bi bi-chevron-down"></i>
              </button>
              @if (languageDropdownOpen) {
                <ul class="guest-footer__language-dropdown">
                  @for (lang of languages; track lang.value) {
                    <li>
                      <button 
                        type="button"
                        class="guest-footer__language-option"
                        (click)="selectLanguage(lang)"
                      >
                        {{ lang.label }}
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>

            <!-- Social Media Icons -->
            <div class="guest-footer__social">
              @for (social of socialLinks; track social.url) {
                <a 
                  [href]="social.url" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  class="guest-footer__social-icon"
                  [attr.aria-label]="social.icon"
                >
                  <i [class]="social.icon"></i>
                </a>
              }
            </div>
          </div>
        </div>

        <!-- Right Section: Newsletter Signup -->
        <div class="guest-footer__newsletter">
          <h4 class="guest-footer__newsletter-title">Be the First to Know What's New</h4>
          <form [formGroup]="newsletterForm" class="guest-footer__newsletter-form">
            <div class="guest-footer__form-field ">
              <label class="guest-footer__label" for="newsletter-name">Name</label>
              <input
                id="newsletter-name"
                type="text"
                formControlName="name"
                class="guest-footer__input"
              />
            </div>
            <div class="guest-footer__form-field">
              <label class="guest-footer__label" for="newsletter-email">Email Address</label>
              <input
                id="newsletter-email"
                type="email"
                formControlName="email"
                class="guest-footer__input"
                [class.guest-footer__input--invalid]="emailControl.invalid && emailControl.touched"
              />
              @if (emailControl.invalid && emailControl.touched) {
                <span class="guest-footer__error">Please enter a valid email address</span>
              }
            </div>
         <p class="guest-footer__disclaimer">
              By providing this information, you agree that we may process your personal data in accordance with our 
              <a 
                [routerLink]="['/', APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.PRIVACY_POLICY]" 
                class="guest-footer__disclaimer-link"
                target="_blank"
                rel="noopener noreferrer"
              >Privacy Statement</a>.
            </p>
            <app-button
              label="Subscribe"
              type="submit"
              variant="primary"
              [disabled]="newsletterForm.invalid"
              size="regular"
              [fullWidth]="true"
              [loading]="isLoading"
               (appClick)="onSubscribe()"
            ></app-button>
            <!-- <button type="submit" class="contact-form-section__submit-button">
            Subscribe
          </button> -->
          </form>
        </div>
      </div>
    <!-- </div> -->
  </div>

  <!-- Bottom Section: Copyright and Legal Links -->
  <div class="guest-footer__bottom">
    <div class="container">
      <div class="guest-footer__bottom-content">
        <p class="guest-footer__copyright">
          © 2026 ICXBee by QUAPT Technologies. All rights reserved.
        </p>
        <div class="guest-footer__legal">
          @for (link of legalLinks; track link.label; let last = $last) {
            <a 
              [routerLink]="link.route" 
              class="guest-footer__legal-link"
              [target]="link.openInNewTab ? '_blank' : '_self'"
              [attr.rel]="link.openInNewTab ? 'noopener noreferrer' : null"
            >{{ link.label }}</a>
            @if (!last) {
              <span class="guest-footer__legal-separator"></span>
            }
          }
        </div>
      </div>
    </div>
  </div>
</footer>
